import { serverSideExperiments } from '@shared/constants/server_side_experiments'
import { useEffect } from 'react'
import { getCookie } from '@/features/shared/utils/cookies'
import { datadogRum } from '@datadog/browser-rum'
export const useSyncServerSideExperimentsWithRum = () => {
  useEffect(() => {
    serverSideExperiments.forEach((experiment) => {
      const serverSideExperimentCookie = getCookie(experiment.cookieGroupKey)
      if (!serverSideExperimentCookie) return
      datadogRum.addFeatureFlagEvaluation(
        experiment.expKey,
        serverSideExperimentCookie, // this will either be control or variation
      )
    })
  }, [])
}
